"use client";

import Link from 'next/link';
import { ThemeToggle } from '@/components/ThemeToggle';
import { useState } from 'react';

export default function ContactPage() {
	const [formData, setFormData] = useState({ name: '', email: '', message: '' });
	const [submitted, setSubmitted] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		
		try {
			const response = await fetch('/api/contact', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			});
			
			const data = await response.json();
			
			if (!response.ok) {
				throw new Error(data.error || 'Något gick fel');
			}
			
			setSubmitted(true);
			setFormData({ name: '', email: '', message: '' });
		} catch (error: any) {
			alert(error.message || 'Kunde inte skicka meddelandet. Försök igen senare.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<main className="min-h-screen bg-gradient-to-b from-slate-50 to-white dark:from-slate-900 dark:to-slate-800">
			<header className="w-full p-6 flex justify-between items-center">
				<Link href="/" className="text-2xl font-bold text-gradient bg-gradient-to-r from-primary-600 via-teal-500 to-primary-600 bg-clip-text text-transparent">
					Karrelo
				</Link>
				<ThemeToggle />
			</header>
			
			<div className="max-w-2xl mx-auto px-6 py-12">
				<h1 className="text-4xl font-bold mb-4 text-slate-900 dark:text-slate-100">Kontakta oss</h1>
				<p className="text-lg text-slate-600 dark:text-slate-400 mb-8">
					Har du frågor eller behöver hjälp? Vi hjälper dig gärna!
				</p>
				
				{!submitted ? (
					<form onSubmit={handleSubmit} className="space-y-6">
						<div>
							<label htmlFor="name" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
								Namn
							</label>
							<input
								type="text"
								id="name"
								required
								value={formData.name}
								onChange={(e) => setFormData({ ...formData, name: e.target.value })}
								className="input-base w-full"
								placeholder="Ditt namn"
							/>
						</div>
						
						<div>
							<label htmlFor="email" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
								E-post
							</label>
							<input
								type="email"
								id="email"
								required
								value={formData.email}
								onChange={(e) => setFormData({ ...formData, email: e.target.value })}
								className="input-base w-full"
								placeholder="din@epost.se"
							/>
						</div>
						
						<div>
							<label htmlFor="message" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
								Meddelande
							</label>
							<textarea
								id="message"
								required
								rows={6}
								value={formData.message}
								onChange={(e) => setFormData({ ...formData, message: e.target.value })}
								className="input-base w-full"
								placeholder="Ditt meddelande..."
							/>
						</div>
						
						<button
							type="submit"
							disabled={loading}
							className="btn-primary w-full py-3"
						>
							{loading ? 'Skickar...' : 'Skicka meddelande'}
						</button>
					</form>
				) : (
					<div className="card-glass rounded-2xl p-8 text-center">
						<div className="text-5xl mb-4">✓</div>
						<h2 className="text-2xl font-semibold mb-2 text-slate-900 dark:text-slate-100">
							Tack för ditt meddelande!
						</h2>
						<p className="text-slate-600 dark:text-slate-400 mb-6">
							Vi har mottagit ditt meddelande och återkommer så snart som möjligt.
						</p>
						<Link href="/" className="btn-outline">
							Tillbaka till startsidan
						</Link>
					</div>
				)}
				
				<div className="mt-12 pt-8 border-t border-slate-200 dark:border-slate-800">
					<div className="space-y-4">
						<div>
							<h3 className="font-semibold text-slate-900 dark:text-slate-100 mb-2">E-post</h3>
							<a href="mailto:support@karrelo.com" className="text-primary-600 dark:text-primary-400 hover:underline">
								support@karrelo.com
							</a>
						</div>
						<div>
							<h3 className="font-semibold text-slate-900 dark:text-slate-100 mb-2">Support</h3>
							<p className="text-slate-600 dark:text-slate-400">
								Vi svarar vanligtvis inom 24 timmar på vardagar.
							</p>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}

